import CableOutlinedIcon from "@mui/icons-material/CableOutlined";
import LightTooltip from "./LightTooltip";
import { providerLabel } from "../../utils/textUtils";

interface PpLogoProps {
  ppType: string;
  fallback?: string;
  size?: number;
}

export default function PpLogo({ ppType, fallback, size = 20 }: PpLogoProps) {
  const lowerCaseType = ppType?.toLowerCase();
  const displayName = providerLabel(ppType);

  if (lowerCaseType === 'stripe') {
    return (
      <LightTooltip title={displayName} placement="top-end">
        <svg width={size} height={size} viewBox="0 0 24 24" fill="#635BFF">
          <path d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.92 3.445 1.574 3.445 2.583 0 .98-.84 1.545-2.354 1.545-1.875 0-4.965-.921-6.99-2.109l-.9 5.555C5.175 22.99 8.385 24 11.714 24c2.641 0 4.843-.624 6.328-1.813 1.664-1.305 2.525-3.236 2.525-5.732 0-4.128-2.524-5.851-6.594-7.305h.003z" />
        </svg>
      </LightTooltip>
    );
  }

  if (lowerCaseType === 'shopify') {
    return (
      <LightTooltip title={displayName} placement="top-end">
        <svg width={size} height={size} viewBox="0 0 89 101" xmlns="http://www.w3.org/2000/svg">
          <path fill="#95BF47" d="M77.667 19.756c-.07-.505-.51-.785-.877-.816-.363-.03-7.482-.139-7.482-.139s-5.954-5.781-6.542-6.37c-.588-.588-1.736-.41-2.183-.277-.006.003-1.118.347-2.99.927a20.969 20.969 0 00-1.433-3.518c-2.12-4.045-5.224-6.184-8.974-6.19h-.014c-.261 0-.52.025-.78.047a11.451 11.451 0 00-.338-.39c-1.635-1.749-3.73-2.6-6.24-2.525-4.844.138-9.668 3.637-13.58 9.851-2.752 4.373-4.847 9.866-5.44 14.119l-9.539 2.954c-2.808.883-2.896.969-3.263 3.616-.271 2-7.618 58.807-7.618 58.807L61.94 100.5l26.683-6.633S77.737 20.26 77.667 19.756zM54.51 14.035l-4.778 1.479c-.036-2.453-.327-5.865-1.47-8.814 3.676.696 5.485 4.855 6.248 7.335zm-7.999 2.477l-10.279 3.183c.994-3.804 2.877-7.591 5.191-10.074.86-.924 2.064-1.953 3.49-2.541 1.34 2.796 1.632 6.755 1.598 9.432zm-6.6-12.784c1.138-.025 2.095.225 2.913.763-1.31.68-2.574 1.657-3.762 2.93-3.076 3.301-5.435 8.426-6.375 13.37-2.933.907-5.801 1.797-8.442 2.613 1.667-7.782 8.19-19.46 15.666-19.676z" />
          <path fill="#5E8E3E" d="M76.793 18.943c-.363-.03-7.482-.139-7.482-.139s-5.954-5.782-6.542-6.37c-.22-.219-.516-.333-.827-.38l.003 88.443 26.68-6.63S77.74 20.263 77.67 19.758c-.07-.504-.513-.785-.877-.815z" />
          <path fill="#fff" d="M47.152 32.662l-3.099 11.594s-3.456-1.573-7.554-1.315c-6.01.38-6.073 4.17-6.012 5.121.327 5.186 13.969 6.318 14.734 18.463.602 9.555-5.068 16.092-13.239 16.608-9.807.618-15.206-5.166-15.206-5.166l2.078-8.84s5.435 4.101 9.785 3.827c2.841-.18 3.856-2.492 3.754-4.126-.428-6.764-11.536-6.364-12.238-17.478-.59-9.352 5.552-18.83 19.104-19.684 5.221-.336 7.893.996 7.893.996z" />
        </svg>
      </LightTooltip>
    );
  }

  if (lowerCaseType === 'paypal') {
    return (
      <LightTooltip title={displayName} placement="top-end">
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 154.728 190.5">
          <g transform="translate(898.192 276.071)">
            <path clipPath="none" d="M-837.663-237.968a5.49 5.49 0 0 0-5.423 4.633l-9.013 57.15-8.281 52.514-.005.044.01-.044 8.281-52.514c.421-2.669 2.719-4.633 5.42-4.633h26.404c26.573 0 49.127-19.387 53.246-45.658.314-1.996.482-3.973.52-5.924v-.003h-.003c-6.753-3.543-14.683-5.565-23.372-5.565z" fill="#001c64" />
            <path clipPath="none" d="M-766.506-232.402c-.037 1.951-.207 3.93-.52 5.926-4.119 26.271-26.673 45.658-53.246 45.658h-26.404c-2.701 0-4.999 1.964-5.42 4.633l-8.281 52.514-5.197 32.947a4.46 4.46 0 0 0 4.405 5.153h28.66a5.49 5.49 0 0 0 5.423-4.633l7.55-47.881c.423-2.669 2.722-4.636 5.423-4.636h16.876c26.573 0 49.124-19.386 53.243-45.655 2.924-18.649-6.46-35.614-22.511-44.026z" fill="#0070e0" />
            <path clipPath="none" d="M-870.225-276.071a5.49 5.49 0 0 0-5.423 4.636l-22.489 142.608a4.46 4.46 0 0 0 4.405 5.156h33.351l8.281-52.514 9.013-57.15a5.49 5.49 0 0 1 5.423-4.633h47.782c8.691 0 16.621 2.025 23.375 5.563.46-23.917-19.275-43.666-46.412-43.666z" fill="#003087" />
          </g>
        </svg>
      </LightTooltip>
    );
  }

  if (lowerCaseType === 'adyen') {
    return (
      <LightTooltip title={displayName} placement="top-end">
        <img
          src="/images/payment-processors/adyen.png"
          alt="Adyen"
          style={{ height: size, width: 'auto', maxWidth: 'none', display: 'block' }}
        />
      </LightTooltip>
    );
  }

  if (lowerCaseType === 'checkout_champ') {
    return (
      <LightTooltip title="Checkout Champ" placement="top-end">
        <img
          src="/images/payment-processors/checkout-champ.png"
          alt="Checkout Champ"
          style={{ height: size, width: 'auto', maxWidth: 'none', display: 'block' }}
        />
      </LightTooltip>
    );
  }

  if (lowerCaseType === 'crm_connector') {
    return (
      <LightTooltip title={displayName} placement="top-end">
        <CableOutlinedIcon sx={{ fontSize: size }} />
      </LightTooltip>
    );
  }

  // Fallback: caller-supplied placeholder (e.g. a dash), else the type name as text
  return (
    <LightTooltip title={displayName} placement="top-end">
      <span>{fallback ?? displayName}</span>
    </LightTooltip>
  );
}

